import {BaseContainerModel} from  '../../base-container.model'
import { bl_dgmkt_schedule_hdr_RowClass, bl_dgmkt_schedule_hdr_RowInterface} from '../../../dbschema/bl_dgmkt_schedule_hdr.model'
import { bl_dgmkt_schedule_line_RowClass } from '../../../dbschema/bl_dgmkt_schedule_line.model'
import { bl_dgmkt_schedule_ext_RowClass } from '../../../dbschema/bl_dgmkt_schedule_ext.model'
import { bl_dgmkt_schedule_event_RowClass } from '../../../dbschema/bl_dgmkt_schedule_event.model'

export class DgMktScheduleContainerModel extends BaseContainerModel{
    bl_dgmkt_schedule_hdr : bl_dgmkt_schedule_hdr_RowInterface = new bl_dgmkt_schedule_hdr_RowClass()
    bl_dgmkt_schedule_lines : bl_dgmkt_schedule_line_RowClass[] = []
    bl_dgmkt_schedule_exts : bl_dgmkt_schedule_ext_RowClass [] = []
    // bl_dgmkt_schedule_event : bl_dgmkt_schedule_event_RowClass [] = []
}
